import { type UseQueryResult, useQuery } from 'react-query';
import {
  ReleaseAppSharedService,
  ReleaseService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetRsuTransactionHIstory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto[] | undefined,
  unknown
> => {
  const rsuTransactionHistory = useQuery(['getRsuTransactionHistory'], async () => {
    return await handleRequest(
      ReleaseAppSharedService.getApiAwardApiAppReleaseRsuTransactionListByAwardId(id)
    );
  });

  return rsuTransactionHistory;
};

export default useGetRsuTransactionHIstory;
